module.exports = __webpack_public_path__ + "img/wuLong4.df6c3300.png";